import { render } from "./Select.vue?vue&type=template&id=5e183571&ts=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/apprelax.webweb.works/client/apprelax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__